export default __webpack_public_path__ + "static/media/ancillery-time-yellow.3b450990.png";